import React from 'react';

const SvgWithLabels = ({ company, score }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1165.55 345.25">
    <defs>
      <style>
        {`
          .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {
            fill: #fff;
          }
          .cls-1, .cls-3 {
            font-family: SFPro-Regular, 'SF Pro';
            font-size: 31px;
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 400;
          }
          .cls-2 {
            font-family: SFPro-Medium, 'SF Pro';
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 510;
            font-weight: 500;
            font-size: 25px;
          }
          .cls-5, .cls-6 {
            font-family: SFPro-Bold, 'SF Pro';
            font-variation-settings: 'wdth' 100, 'opsz' 28, 'wght' 700;
            font-weight: 700;
          }
          .cls-5 {
            font-size: 25px;
          }
          .cls-6 {
            font-size: 28.71px;
          }
          .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {
            stroke-miterlimit: 10;
          }
          .cls-7, .cls-9, .cls-12, .cls-13 {
            fill: none;
            stroke: #f2f2f2;
          }
          .cls-8 {
            fill: #084891;
            stroke: #fff;
            opacity: .4;
          }
          .cls-10 {
            fill: #44adff;
            stroke: #fff;
          }
          .cls-11 {
            fill: #0994ff;
            stroke: #fff;
            opacity: .4;
          }
          .cls-14 {
            fill: #007aff;
            stroke: #fff;
            opacity: .4;
          }
          .cls-9 {
            stroke-dasharray: 4.62 4.62;
          }
          .cls-12 {
            stroke-dasharray: 4 4;
          }
          .cls-13 {
            stroke-dasharray: 4.02 4.02;
          }
        `}
      </style>
    </defs>

    {/* Rectangles */}
    <rect className="cls-10" x="38.02" y="20.05" width="273.32" height="112.94"/>
    <rect className="cls-14" x="311.34" y="20.05" width="273.32" height="112.94"/>
    <rect className="cls-11" x="584.66" y="20.05" width="273.32" height="112.94"/>
    <rect className="cls-8" x="857.97" y="20.05" width="273.32" height="112.94"/>

    {/* Stage Labels */}
    <text className="cls-1" transform="translate(121.8 84.97)">Outpost</text>
    <text className="cls-1" transform="translate(396.68 87.44)">Satellite</text>
    <text className="cls-1" transform="translate(636.57 87.44)">Portfolio Hub</text>
    <text className="cls-3" transform="translate(867.47 87.44)">Transformation Hub</text>

    {/* Arrow and dotted lines */}
    <g>
      <line className="cls-7" x1="38.02" y1="171.58" x2="38.02" y2="173.58"/>
      <line className="cls-9" x1="38.02" y1="178.2" x2="38.02" y2="194.37"/>
      <polyline className="cls-7" points="38.02 196.68 38.02 198.68 40.02 198.68"/>
      <line className="cls-13" x1="44.04" y1="198.68" x2="307.33" y2="198.68"/>
      <polyline className="cls-7" points="309.34 198.68 311.34 198.68 311.34 196.68"/>
      <line className="cls-9" x1="311.34" y1="192.06" x2="311.34" y2="175.89"/>
      <line className="cls-7" x1="311.34" y1="173.58" x2="311.34" y2="171.58"/>
    </g>

    {/* Down arrow */}
    <line className="cls-12" x1="174.68" y1="227.39" x2="174.68" y2="201.68"/>
    <polygon className="cls-4" points="166.01 227.92 174.68 239.48 183.36 227.92 166.01 227.92"/>

    {/* Numbers above boxes */}
    <text className="cls-6" transform="translate(30.94 162.07)">1</text>
    <text className="cls-6" transform="translate(302.68 162.07)">2</text>
    <text className="cls-6" transform="translate(575.61 162.07)">3</text>
    <text className="cls-6" transform="translate(848.68 162.07)">4</text>
    <text className="cls-6" transform="translate(1122.32 162.07)">5</text>

    {/* Dynamic Company and Score */}
   <text class="cls-5" transform="translate(83.82 282.33)">
      <tspan x="60" y="0">{company}</tspan>
    </text>
    <text class="cls-2" transform="translate(130.93 319.19)">
      <tspan x="-20" y="0">Maturity Index: {score}</tspan>
    </text>
  </svg>
);

export default SvgWithLabels;
